export default function YachtDiceIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true">
      <g transform="rotate(-14 22 36)">
        <rect x="6" y="20" width="32" height="32" rx="7" fill="#fffdf6" stroke="#2F8BFF" strokeWidth="3" />
        <circle cx="14" cy="28" r="3" fill="#1b1f2a" />
        <circle cx="30" cy="28" r="3" fill="#1b1f2a" />
        <circle cx="22" cy="36" r="3" fill="#1b1f2a" />
        <circle cx="14" cy="44" r="3" fill="#1b1f2a" />
        <circle cx="30" cy="44" r="3" fill="#1b1f2a" />
      </g>
      <g transform="rotate(12 44 24)">
        <rect x="30" y="8" width="28" height="28" rx="6" fill="#fffdf6" stroke="#FF8A1F" strokeWidth="3" />
        <circle cx="44" cy="22" r="4" fill="#e0322b" />
      </g>
      <path d="M44 44l3 6 6 1-4.5 4 1 6-5.5-3-5.5 3 1-6-4.5-4 6-1z" fill="#ffd84d" stroke="#b8860b" strokeWidth="1.5" />
    </svg>
  );
}
